import api, { setAuthorizationToken } from './api';


export interface Account {
  username: string;
  password: string;
}

export const loginFornecedor = (account: Account) =>
  api.post<Account>('account/authenticate', account, {
    disableNotification: false,
  });

export const forgotPassword = (userName: string) => {
  let data = { userName: userName };
  return api.post('account/forgotPassword', data, { disableNotification: 'true' });
};

export const resetPassword = (code: string, newPassword: string) => {
  let data = { code: code, newPassword: newPassword };
  return api.post('account/resetPassword', data, { disableNotification: 'true' });
};

export const getPermissions = async () => {
  const token = localStorage.getItem('idtoken');
  if (token) {
    setAuthorizationToken(token);
  }

  return api.post('account/permissions/sso', {}, { disableNotification: false });
};